import React from 'react'
import {Modal} from 'antd'
import styled from 'styled-components'
import warning from '../../img/warning.png'
import errorCodeConstant from "../../constants/errorCode";
const WarningImg = styled.img`
  width: 48px;
  text-align: center;
`
const Center = styled.div`
  text-align: center;
  margin-bottom: 16px;
`
const Content = styled.div`
  height: 150px;
`
const Info = styled.p`
  text-align: center;
`
const ErrorModal= ({errorCode}) => {
  return (
    <Modal
      title="提示"
      visible={errorCodeConstant.has(errorCode)}
      closable={false}
      width={720}
      footer={
        null
      }
    >
      <Content>
        <Center>
          <WarningImg src={warning} alt={"警告"}/>
        </Center>
        {
          (errorCode === 1004 || errorCode === 1005) && <Info>您的产品授权发生变更，无法继续使用，</Info>
        }
        {
          (errorCode === 1003) && <Info>当前用户在不可见范围内，无法继续使用，</Info>
        }
        <Info>
          如需继续使用，请联系管理员
        </Info>
      </Content>
    </Modal>
  )
}

export default ErrorModal
